/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useState, useEffect, useRef } from "react";

export interface PageDoc {
  _id: string;
  title: string;
  slug: string;
  content?: string;
  template?: string;
  createdAt?: string;
  updatedAt?: string;
}

interface UsePagesResult {
  data: PageDoc[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function usePages(): UsePagesResult {
  const [data, setData] = useState<PageDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const didFetch = useRef(false); // 🔥 prevents retry loop

  const fetchPages = async () => {
    if (!API_URL) return;

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API_URL}/api/v1/howtohub`, {
        cache: "no-store",
      });

      // 🔥 IMPORTANT: DO NOT THROW
      if (!res.ok) {
        console.warn("Pages API failed:", res.status);
        setData([]);
        return;
      }

      const json = await res.json();
      setData(json?.data || []);
    } catch (err: any) {
      // 🔥 swallow fetch/network errors
      console.warn("Pages fetch failed (network)");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (didFetch.current) return; // 🔥 run only once
    didFetch.current = true;

    fetchPages();
  }, []);

  return { data, loading, error, refetch: fetchPages };
}
